import {createContext, useContext} from 'react';

export const initialJobEditPopupValues = {
  iframeElement: null,
};

const JobEditPopupContext = createContext({});
//
// export const usePricingPopupContext = () => {
//   return useContext(JobEditPopupContext);
// }
//
// export const pricingPopupContextReducer = (state = initialPricingPopupValues, action) => {
//   return {...state, ...action};
// }

export default JobEditPopupContext;
